/* Beard & Brawn — variant-aware PDP gallery (v2).

   Shows, per selected variant:
     • SHARED images (tied to no variant) — on EVERY variant, always.
     • the SELECTED variant's own image(s).
   Hides other variants' images (thumbnails AND main slides).

   An image is tied to a variant by EITHER signal, so it survives blank alt text
   and doesn't need a hand-typed convention:
     1. Shopify's native variant→image association, emitted server-side as a
        media-id → option-values map (snippets/product-media-gallery.liquid,
        [data-bb-gallery-map]). This is the robust primary.
     2. The variant's option value appearing in the image ALT text (flexible —
        lets one scent carry several shots).
   ALT containing "all scents" FORCES shared (explicit always-show override).

   Safety: if the filter would hide every main slide, or the product uses neither
   signal, it shows everything and gets out of the way. */
(function () {
  'use strict';

  var SHARED_RE = /all\s*scents?/i;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function readMap() {
    var el = document.querySelector('[data-bb-gallery-map]');
    if (!el) return { values: [], byMedia: {} };
    try {
      var m = JSON.parse(el.textContent) || {};
      return {
        values: (m.values || []).map(function (v) { return ('' + v).toLowerCase(); }),
        byMedia: m.byMedia || {},
      };
    } catch (e) { return { values: [], byMedia: {} }; }
  }

  // Currently selected variant option values (lower-cased).
  function selectedValues() {
    var vals = [];
    document
      .querySelectorAll('.product-form__input input[type="radio"]:checked, .product-form__input input[type="checkbox"]:checked')
      .forEach(function (i) { if (i.value) vals.push(i.value.trim().toLowerCase()); });
    document
      .querySelectorAll('.product-form__input select')
      .forEach(function (s) { if (s.value) vals.push(s.value.trim().toLowerCase()); });
    return vals;
  }

  // Thumbnails carry the media id in data-target; main slides in data-media-id.
  // Both are "<sectionId>-<mediaId>", so the trailing digits are the media id.
  function mediaIdOf(el, attr) {
    var v = el.getAttribute(attr) || '';
    var m = v.match(/(\d+)$/);
    return m ? m[1] : '';
  }
  function altOf(el) {
    var img = el.querySelector('img');
    var a = img && img.getAttribute('alt');
    return a ? a.toLowerCase() : '';
  }

  function ownersFor(mediaId, alt, map) {
    var owners = [];
    var native = map.byMedia[mediaId];
    if (native && native.length) {
      native.forEach(function (v) { v = ('' + v).toLowerCase(); if (owners.indexOf(v) === -1) owners.push(v); });
    }
    map.values.forEach(function (v) {
      if (v && alt.indexOf(v) !== -1 && owners.indexOf(v) === -1) owners.push(v);
    });
    return owners;
  }

  // Returns true if this item should be visible for the selected variant.
  function shouldShow(el, attr, map, selected) {
    var alt = altOf(el);
    if (SHARED_RE.test(alt)) return true;                 // explicit "all scents" → always
    var owners = ownersFor(mediaIdOf(el, attr), alt, map);
    if (owners.length === 0) return true;                 // unowned → shared → always
    return owners.some(function (v) { return selected.indexOf(v) !== -1; });
  }

  function apply() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var map = readMap();
    var selected = selectedValues();
    if (!selected.length) return;

    // Thumbnails
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    var tVisible = 0;
    thumbs.forEach(function (item) {
      var show = shouldShow(item, 'data-target', map, selected);
      item.hidden = !show;
      if (show) tVisible++;
    });

    // Main slides — same filter, but never hide the active slide (avoids a blank
    // stage if a variant has no image of its own; the active one is set by Dawn).
    var slides = gallery.querySelectorAll('.product__media-item');
    var sVisible = 0;
    slides.forEach(function (sl) {
      var show = sl.classList.contains('is-active') || shouldShow(sl, 'data-media-id', map, selected);
      sl.hidden = !show;
      if (show) sVisible++;
    });

    // If the filter would hide everything (misconfigured product), get out of the way.
    if (sVisible === 0) {
      slides.forEach(function (sl) { sl.hidden = false; });
      thumbs.forEach(function (it) { it.hidden = false; });
      tVisible = thumbs.length;
    }

    // A lone thumbnail just mirrors the main image — hide the whole strip then.
    var strip = gallery.querySelector('.thumbnail-slider');
    if (strip && thumbs.length) strip.hidden = tVisible < 2;

    // Lead the thumbnail carousel with the first visible shot.
    var list = gallery.querySelector('.thumbnail-list');
    if (list && list.scrollTo) list.scrollTo({ left: 0 });
  }

  function init() {
    if (!document.querySelector('media-gallery')) return;
    apply();

    // Preferred: Dawn publishes PUB_SUB_EVENTS.variantChange AFTER it swaps the
    // gallery media (updateMedia), so we re-filter strictly against the new DOM.
    var usingPubSub = false;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      usingPubSub = true;
      subscribe(PUB_SUB_EVENTS.variantChange, function () { apply(); });
    }

    // Fallback for flows that don't publish variantChange.
    if (!usingPubSub) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-form__input')) apply();
      });
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-form__input--pill label, .product-form__input--pill')) apply();
      });
    }
  }

  ready(init);
})();
